import { useDataQuery } from '@dhis2/app-runtime'
import { useEffect } from 'react'

const PERFORMANCE_HIERARCHY_QUERY = {
  goals: {
    resource: 'events',
    params: () => ({
      program: 'NkReudUAW4F',
      programStage: 'VomTWbJot7U',
      fields: 'event,programStage,orgUnit,orgUnitName,eventDate,dueDate,status,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  },
  // ALL events are in the SAME program (yiT00XKrrHP) but different stages
  objectives: {
    resource: 'events',
    params: ({ orgUnitId }) => ({
      program: 'yiT00XKrrHP', // CORRECT: All events use this program ID
      programStage: 'VIBtpvkpHFR', // Objective stage
      orgUnit: orgUnitId,
      ouMode: 'ACCESSIBLE', // Changed from DESCENDANTS
      fields: 'event,programStage,orgUnit,orgUnitName,eventDate,dueDate,status,trackedEntityInstance,enrollment,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  },
  kras: {
    resource: 'events',
    params: ({ orgUnitId }) => ({
      program: 'yiT00XKrrHP', // CORRECT: Same program, NOT BJb3qTgbcTF
      programStage: 'BJb3qTgbcTF', // KRA stage
      orgUnit: orgUnitId,
      ouMode: 'ACCESSIBLE',
      fields: 'event,programStage,orgUnit,orgUnitName,eventDate,dueDate,status,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  },
  kpis: {
    resource: 'events',
    params: ({ orgUnitId }) => ({
      program: 'yiT00XKrrHP', // CORRECT: Same program, NOT ivyCLjNLFrd
      programStage: 'ivyCLjNLFrd', // KPI stage
      orgUnit: orgUnitId,
      ouMode: 'ACCESSIBLE',
      fields: 'event,programStage,orgUnit,orgUnitName,eventDate,dueDate,status,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  },
  tasks: {
    resource: 'events',
    params: ({ orgUnitId }) => ({
      program: 'yiT00XKrrHP',
      programStage: 'Nv9nYNcBTdM', // Task stage
      orgUnit: orgUnitId,
      ouMode: 'ACCESSIBLE',
      fields: 'event,programStage,orgUnit,orgUnitName,eventDate,dueDate,status,trackedEntityInstance,dataValues[dataElement,value]',
      pageSize: 1000,
      totalPages: true
    })
  },
  // POSITIONS: We need to find the correct Tracked Entity Type ID
  // From your logs, this returns 0, so it's wrong
  positions: {
    resource: 'trackedEntityInstances',
    params: () => ({
      trackedEntityType: 'UGGo0Ebjl0E',
      ouMode: 'ACCESSIBLE',
      fields: 'trackedEntityInstance,attributes[attribute,value]',
      pageSize: 1000
    })
  },
  staff: {
    resource: 'trackedEntityInstances',
    params: () => ({
      trackedEntityType: 'OaAbpIs1cV7',
      ouMode: 'ACCESSIBLE',
      fields: 'trackedEntityInstance,attributes[attribute,value]',
      pageSize: 1000
    })
  },
  users: {
    resource: 'users',
    params: {
      fields: 'id,displayName,firstName,surname,username,organisationUnits[id,name],userCredentials[userRoles[id,name]]',
      pageSize: 1000
    }
  }
}

export const usePerformanceHierarchy = (orgUnitId, rootOrgUnitId) => {
  const effectiveOrgUnitId = rootOrgUnitId || orgUnitId;
  const shouldFetch = !!effectiveOrgUnitId;
    
  const { loading, error, data } = useDataQuery(PERFORMANCE_HIERARCHY_QUERY, {
    variables: { orgUnitId: effectiveOrgUnitId },
    skip: !shouldFetch
  })

  useEffect(() => {
    if (data && shouldFetch) {
      console.log('✅ usePerformanceHierarchy Data:', {
        goals: data.goals?.events?.length || 0,
        objectives: data.objectives?.events?.length || 0,
        kras: data.kras?.events?.length || 0,
        kpis: data.kpis?.events?.length || 0,
        tasks: data.tasks?.events?.length || 0,
        positions: data.positions?.trackedEntityInstances?.length || 0,
        staff: data.staff?.trackedEntityInstances?.length || 0,
        users: data.users?.users?.length || 0
      });
    }
  }, [data, shouldFetch]);

  if (error) {
    console.error('❌ usePerformanceHierarchy Error:', error);
  }
  
  return { 
    loading: shouldFetch ? loading : false, 
    error: shouldFetch ? error : null, 
    data: shouldFetch ? data : null
  }
}
